export default "__VITE_ASSET__D6TcP0sX__"